const { createReducer } = require('../helpers')
const {
  // For Admin Panel
  GET_PRESCRIPTION_LIST,
  GET_PRESCRIPTION_LIST_SUCCESS,
  GET_PRESCRIPTION_LIST_ERROR,
  GET_PRESCRIPTION_LIST_RESET,

  // For Admin Panel
  GET_PRESCRIPTION,
  GET_PRESCRIPTION_SUCCESS,
  GET_PRESCRIPTION_ERROR,
  GET_PRESCRIPTION_RESET,

  // For Admin Panel
  CREATE_PRESCRIPTION,
  CREATE_PRESCRIPTION_SUCCESS,
  CREATE_PRESCRIPTION_ERROR,
  CREATE_PRESCRIPTION_RESET,

  // For Admin Panel
  UPDATE_PRESCRIPTION,
  UPDATE_PRESCRIPTION_SUCCESS,
  UPDATE_PRESCRIPTION_ERROR,
  UPDATE_PRESCRIPTION_RESET,

  // For Admin Panel
  DELETE_PRESCRIPTION,
  DELETE_PRESCRIPTION_SUCCESS,
  DELETE_PRESCRIPTION_ERROR,
  DELETE_PRESCRIPTION_RESET,

  // For Admin Panel
  UPDATE_PRESCRIPTION_STATUS,
  UPDATE_PRESCRIPTION_STATUS_SUCCESS,
  UPDATE_PRESCRIPTION_STATUS_ERROR,
  UPDATE_PRESCRIPTION_STATUS_RESET,

  // For Admin Panel
  ADD_PRESCRIPTION_VALIDITY,
  ADD_PRESCRIPTION_VALIDITY_SUCCESS,
  ADD_PRESCRIPTION_VALIDITY_ERROR,
  ADD_PRESCRIPTION_VALIDITY_RESET,

  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA,
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_SUCCESS,
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_ERROR,
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_RESET,
  POST_DOCTOR_PRESCRIPTION_DATA,
  POST_DOCTOR_PRESCRIPTION_DATA_SUCCESS,
  POST_DOCTOR_PRESCRIPTION_DATA_ERROR,
  POST_DOCTOR_PRESCRIPTION_DATA_RESET,
  GET_PATIENT_PRESCRIPTION_DATA,
  GET_PATIENT_PRESCRIPTION_DATA_SUCCESS,
  GET_PATIENT_PRESCRIPTION_DATA_ERROR,
  GET_PATIENT_PRESCRIPTION_DATA_RESET,
  GET_MD_PRESCRIPTION_NEW_LINK,
  GET_MD_PRESCRIPTION_NEW_LINK_SUCCESS,
  GET_MD_PRESCRIPTION_NEW_LINK_ERROR,
  GET_MD_PRESCRIPTION_NEW_LINK_RESET,

  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA,
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_SUCCESS,
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_ERROR,
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_RESET,

  POST_FOR_PRESCRIPTION_NOTIFICATION,
  POST_FOR_PRESCRIPTION_NOTIFICATION_SUCCESS,
  POST_FOR_PRESCRIPTION_NOTIFICATION_ERROR,
  POST_FOR_PRESCRIPTION_NOTIFICATION_RESET,
} = require('./constants')

const initialState = {
  prescriptionList: {
    data: null,
    loading: false,
    error: null,
  },
  prescription: {
    data: null,
    loading: false,
    error: null,
  },
  create: {
    data: null,
    loading: false,
    error: null,
  },
  update: {
    data: null,
    loading: false,
    error: null,
  },
  delete: {
    data: null,
    loading: false,
    error: null,
  },
  updatePrescriptionStatus: {
    data: null,
    loading: false,
    error: null,
  },
  addPrescriptionValidity: {
    data: null,
    loading: false,
    error: null,
  },
  doctorPrescriptionSearchValueState: {
    data: null,
    loading: false,
    error: null,
  },
  doctorPrescriptionState: {
    data: null,
    loading: false,
    error: null,
  },
  getPatientPrescriptionDataState: {
    data: null,
    loading: false,
    error: null,
  },
  getMDPrescriptionNewLinkState: {
    data: null,
    loading: false,
    error: null,
  },
  doctorEditPrescriptionSearchValueState: {
    data: null,
    loading: false,
    error: null,
  },
  postForPrescriptionNotificationState: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer({
  [GET_PRESCRIPTION_LIST]: draft => ({
    prescriptionList: {
      ...draft.prescriptionList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_PRESCRIPTION_LIST_SUCCESS]: (draft, action) => ({
    prescriptionList: {
      ...draft.prescriptionList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_PRESCRIPTION_LIST_ERROR]: (draft, action) => ({
    prescriptionList: {
      ...draft.prescriptionList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PRESCRIPTION_LIST_RESET]: () => ({
    prescriptionList: { ...initialState.prescriptionList },
  }),

  [GET_PRESCRIPTION]: draft => ({
    prescription: {
      ...draft.prescription,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_PRESCRIPTION_SUCCESS]: (draft, action) => ({
    prescription: {
      ...draft.prescription,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_PRESCRIPTION_ERROR]: (draft, action) => ({
    prescription: {
      ...draft.prescription,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PRESCRIPTION_RESET]: () => ({
    prescription: { ...initialState.prescription },
  }),

  [CREATE_PRESCRIPTION]: draft => ({
    create: {
      ...draft.create,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [CREATE_PRESCRIPTION_SUCCESS]: (draft, action) => ({
    create: {
      ...draft.create,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CREATE_PRESCRIPTION_ERROR]: (draft, action) => ({
    create: {
      ...draft.create,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CREATE_PRESCRIPTION_RESET]: () => ({
    create: { ...initialState.create },
  }),

  [UPDATE_PRESCRIPTION]: draft => ({
    update: {
      ...draft.update,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_PRESCRIPTION_SUCCESS]: (draft, action) => ({
    update: {
      ...draft.update,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_PRESCRIPTION_ERROR]: (draft, action) => ({
    update: {
      ...draft.update,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_PRESCRIPTION_RESET]: () => ({
    update: { ...initialState.update },
  }),

  [DELETE_PRESCRIPTION]: draft => ({
    delete: {
      ...draft.delete,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [DELETE_PRESCRIPTION_SUCCESS]: (draft, action) => ({
    delete: {
      ...draft.delete,
      loading: false,
      data: action.payload.data,
    },
  }),
  [DELETE_PRESCRIPTION_ERROR]: (draft, action) => ({
    delete: {
      ...draft.delete,
      loading: false,
      error: action.payload.error,
    },
  }),
  [DELETE_PRESCRIPTION_RESET]: () => ({
    delete: { ...initialState.delete },
  }),

  [UPDATE_PRESCRIPTION_STATUS]: draft => ({
    updatePrescriptionStatus: {
      ...draft.updatePrescriptionStatus,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_PRESCRIPTION_STATUS_SUCCESS]: (draft, action) => ({
    updatePrescriptionStatus: {
      ...draft.updatePrescriptionStatus,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_PRESCRIPTION_STATUS_ERROR]: (draft, action) => ({
    updatePrescriptionStatus: {
      ...draft.updatePrescriptionStatus,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_PRESCRIPTION_STATUS_RESET]: () => ({
    updatePrescriptionStatus: { ...initialState.updatePrescriptionStatus },
  }),

  [ADD_PRESCRIPTION_VALIDITY]: draft => ({
    addPrescriptionValidity: {
      ...draft.addPrescriptionValidity,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [ADD_PRESCRIPTION_VALIDITY_SUCCESS]: (draft, action) => ({
    addPrescriptionValidity: {
      ...draft.addPrescriptionValidity,
      loading: false,
      data: action.payload.data,
    },
  }),
  [ADD_PRESCRIPTION_VALIDITY_ERROR]: (draft, action) => ({
    addPrescriptionValidity: {
      ...draft.addPrescriptionValidity,
      loading: false,
      error: action.payload.error,
    },
  }),
  [ADD_PRESCRIPTION_VALIDITY_RESET]: () => ({
    addPrescriptionValidity: { ...initialState.addPrescriptionValidity },
  }),

  [POST_DOCTOR_PRESCRIPTION_SEARCH_DATA]: draft => ({
    doctorPrescriptionSearchValueState: {
      ...draft.doctorPrescriptionSearchValueState,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_SUCCESS]: (draft, action) => ({
    doctorPrescriptionSearchValueState: {
      ...draft.doctorPrescriptionSearchValueState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_ERROR]: (draft, action) => ({
    doctorPrescriptionSearchValueState: {
      ...draft.doctorPrescriptionSearchValueState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_RESET]: () => ({
    doctorPrescriptionSearchValueState: { ...initialState.doctorPrescriptionSearchValueState },
  }),

  [POST_DOCTOR_PRESCRIPTION_DATA]: draft => ({
    doctorPrescriptionState: {
      ...draft.doctorPrescriptionState,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [POST_DOCTOR_PRESCRIPTION_DATA_SUCCESS]: (draft, action) => ({
    doctorPrescriptionState: {
      ...draft.doctorPrescriptionState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_DOCTOR_PRESCRIPTION_DATA_ERROR]: (draft, action) => ({
    doctorPrescriptionState: {
      ...draft.doctorPrescriptionState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_DOCTOR_PRESCRIPTION_DATA_RESET]: () => ({
    doctorPrescriptionState: { ...initialState.doctorPrescriptionState },
  }),

  [GET_PATIENT_PRESCRIPTION_DATA]: draft => ({
    getPatientPrescriptionDataState: {
      ...draft.getPatientPrescriptionDataState,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [GET_PATIENT_PRESCRIPTION_DATA_SUCCESS]: (draft, action) => ({
    getPatientPrescriptionDataState: {
      ...draft.getPatientPrescriptionDataState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_PATIENT_PRESCRIPTION_DATA_ERROR]: (draft, action) => ({
    getPatientPrescriptionDataState: {
      ...draft.getPatientPrescriptionDataState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PATIENT_PRESCRIPTION_DATA_RESET]: () => ({
    getPatientPrescriptionDataState: { ...initialState.getPatientPrescriptionDataState },
  }),

  [GET_MD_PRESCRIPTION_NEW_LINK]: draft => ({
    getMDPrescriptionNewLinkState: {
      ...draft.getMDPrescriptionNewLinkState,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [GET_MD_PRESCRIPTION_NEW_LINK_SUCCESS]: (draft, action) => ({
    getMDPrescriptionNewLinkState: {
      ...draft.getMDPrescriptionNewLinkState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_MD_PRESCRIPTION_NEW_LINK_ERROR]: (draft, action) => ({
    getMDPrescriptionNewLinkState: {
      ...draft.getMDPrescriptionNewLinkState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_MD_PRESCRIPTION_NEW_LINK_RESET]: () => ({
    getMDPrescriptionNewLinkState: { ...initialState.getMDPrescriptionNewLinkState },
  }),

  [POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA]: draft => ({
    doctorEditPrescriptionSearchValueState: {
      ...draft.doctorEditPrescriptionSearchValueState,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_SUCCESS]: (draft, action) => ({
    doctorEditPrescriptionSearchValueState: {
      ...draft.doctorEditPrescriptionSearchValueState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_ERROR]: (draft, action) => ({
    doctorEditPrescriptionSearchValueState: {
      ...draft.doctorEditPrescriptionSearchValueState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_RESET]: () => ({
    // eslint-disable-next-line max-len
    doctorEditPrescriptionSearchValueState: { ...initialState.doctorEditPrescriptionSearchValueState },
  }),

  [POST_FOR_PRESCRIPTION_NOTIFICATION]: draft => ({
    postForPrescriptionNotificationState: {
      ...draft.postForPrescriptionNotificationState,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [POST_FOR_PRESCRIPTION_NOTIFICATION_SUCCESS]: (draft, action) => ({
    postForPrescriptionNotificationState: {
      ...draft.postForPrescriptionNotificationState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_FOR_PRESCRIPTION_NOTIFICATION_ERROR]: (draft, action) => ({
    postForPrescriptionNotificationState: {
      ...draft.postForPrescriptionNotificationState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_FOR_PRESCRIPTION_NOTIFICATION_RESET]: () => ({
    // eslint-disable-next-line max-len
    postForPrescriptionNotificationState: { ...initialState.postForPrescriptionNotificationState },
  }),
}, initialState)
